import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { sentinelSecretsManagerApiRef, SentinelSecretsManagerClient } from './api';

export const sentinelSecretsManagerPlugin = createPlugin({
  id: 'sentinel-secrets-manager',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: sentinelSecretsManagerApiRef,
      deps: { fetchApi: fetchApiRef, discoveryApi: discoveryApiRef },
      factory(deps) {
        return new SentinelSecretsManagerClient(deps);
      },
    }),
  ],
});

export const SentinelSecretsManagerContent = sentinelSecretsManagerPlugin.provide(
  createRoutableExtension({
    name: 'SentinelSecretsManagerContent',
    component: () => import('./components/SecretsManagerContainer').then(m => m.SecretsManagerContainer),
    mountPoint: rootRouteRef,
  }),
);
